<template>
    <div class='line'  :data-word="submissionObj.word" @click='$emit("selectLine")'  >
        <div class='col col1'>{{ submissionObj.word }}</div>
        <div class='col col2'>{{ this.date }}</div>
        <button class="mdl-button mdl-js-button mdl-button--icon btn_deletesub" data-word="'+ submissionObj.word +'" @click="$emit('deleteLigne')">
            <i class="material-icons">delete</i>
        </button>
    </div> 
</template>

<script>
    import FctUtils from '@/components/FctUtils';

    export default {
        name:"SubmissionLine",
        mixins: [FctUtils],
        props:{
            submissionObj: {type:Object},
            selectedLine:{type:Boolean},
        },
        computed:{
            date: function(){
                if (this.submissionObj.date != '') {
                    var aDateObj = new Date(this.submissionObj.date);
                    return aDateObj.toLocaleString();
                } 
                return "";
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
